'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _events = require('redux/modules/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    location: state.router.location,
    selectedRange: state.events.selectedRange
  };
}, { push: _reduxRouter.push, selectRange: _events.selectRange }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CalendarContainer, _Component);

  function CalendarContainer() {
    (0, _classCallCheck3.default)(this, CalendarContainer);
    return (0, _possibleConstructorReturn3.default)(this, (CalendarContainer.__proto__ || (0, _getPrototypeOf2.default)(CalendarContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(CalendarContainer, [{
    key: 'onSelect',
    value: function onSelect(moment) {
      var _props = this.props,
          push = _props.push,
          location = _props.location,
          selectRange = _props.selectRange,
          selectedRange = _props.selectedRange; // eslint-disable-line no-shadow

      var start = moment.clone().startOf('day');
      var end = start.clone().endOf('day');
      var isSameDay = moment.isSame(selectedRange.start, 'day');
      var query = (0, _extends3.default)({}, location.query, {
        page: 1
      });

      if (isSameDay) {
        // Remove range from query
        delete query.range;
        selectRange({ start: null, end: null });
      } else {
        // Add/update range to query
        var format = 'YYYY-MM-DD HH:mm:ss';
        query.range = start.format(format) + ',' + end.format(format);
      }

      push({ pathname: '/evenements', query: query });

      return true; // Calendar flag...
    }
  }, {
    key: 'render',
    value: function render() {
      var moment = this.context.moment;
      var selectedRange = this.props.selectedRange;

      var date = null;

      if (selectedRange && selectedRange.start) {
        date = moment(selectedRange.start);
      }

      return _react2.default.createElement(_caligramReact.Calendar, { date: date, locale: 'fr', onSelect: this.onSelect.bind(this) });
    }
  }]);
  return CalendarContainer;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  push: _react.PropTypes.func.isRequired,
  selectRange: _react.PropTypes.func.isRequired,
  selectedRange: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  moment: _react.PropTypes.func
}, _temp)) || _class);
exports.default = CalendarContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CalendarContainer.js
// module id = 1088
// module chunks = 0